export { default } from './Link';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Link/index.js
// module id = 338
// module chunks = 0